import React from "react";
import aboutImg from "../../Image/1.jpg";
import whyImg from "../../Image/5.jpg";
import serviceImg from "../../Image/2.webp";
import diffImg from "../../Image/different.jpg";
import "./About.css";

const About = () => {
  const blocks = [
    {
      title: "Who We Are",
      desc:
        "StanTech Solutions Ltd delivers offshore business process outsourcing solutions with a strong focus on real estate management and IT-enabled services. With proven experience supporting multi-state operations and leading national clients across the United States, we play a key role in the property preservation industry. Founded by seasoned IT professionals, our organization is powered by talented business graduates and engineers from globally recognized institutions. Beyond BPO, we offer end-to-end digital solutions including web design, software and mobile app development, information systems security, and network security services.",
      image: aboutImg
    },
    
    {
      title: "What Makes Us Different",
      desc:
        "Honesty and integrity are at the core of our operations, and customer satisfaction is our highest priority. We foster open and transparent communication by building strong relationships with our clients from the very beginning. To ensure the safety and preservation of your assets, all team members undergo thorough criminal background checks prior to employment, ensuring only qualified and trustworthy professionals work on your property. Our staff is carefully trained to align with our service standards, reinforced through ongoing monthly training sessions that cover new industry regulations and best practices.",
      image: diffImg
    }
  ];

  return (
    <section id="About" className="about-wrapper">
      <div className="about-header">
        <h2>StanTech Solutions Ltd</h2>
        <p>
          A modern property maintenance partner built for speed, transparency,
          and nationwide scalability.
        </p>
      </div>

      <div className="about-grid">
        {blocks.map((item, index) => (
          <div className="about-card" key={index}>
            <div className="about-card-img">
              <img src={item.image} alt={item.title} />
            </div>

            <div className="about-card-content">
              <h3>{item.title}</h3>

              {item.desc && <p>{item.desc}</p>}

              {item.points && (
                <ul>
                  {item.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default About;
